import moment from 'moment';
import { useSetState } from 'ahooks';
import { isUndefined } from '@/utils/common';

interface IReturn {
  continueButtonDisalbed: boolean;
  onChangeFormItem: (field: string, value: any) => any;
  disabledDate: {
    start: (current: moment.Moment) => boolean;
    end: (current: moment.Moment) => boolean;
  };
}

interface IPrams {
  (values?: any): IReturn;
}

const useFormItemReaction: IPrams = (values = {}) => {
  const [formValues, setFormValues] = useSetState<any>(values);
  const isDestinationUndefined = isUndefined(formValues?.destination);
  const isTravelStartDateUndefined = isUndefined(formValues?.travel_start_date);
  const isTravelEndDateUndefined = isUndefined(formValues?.travel_end_date);

  const continueButtonDisalbed =
    isDestinationUndefined ||
    isTravelStartDateUndefined ||
    isTravelEndDateUndefined;

  const onChangeFormItem = (field: string, value: any) =>
    setFormValues({ [field]: value });

  const disabledDate = {
    start: (current: moment.Moment) => {
      const pickerEndDate = formValues?.travel_end_date
        ? moment(formValues?.travel_end_date).endOf('day')
        : undefined;
      const nextYearStart = moment().add(1, 'years').startOf('day');

      const startDate = moment().startOf('day');
      const endDate = pickerEndDate ?? nextYearStart;

      return current && (current < startDate || current > endDate);
    },
    end: (current: moment.Moment) => {
      const pickerStartDate = formValues?.travel_start_date
        ? moment(formValues?.travel_start_date).startOf('day')
        : undefined;
      const today = moment().startOf('day');

      const startDate = pickerStartDate ?? today;
      const endDate = moment(startDate).add(1, 'years').startOf('day');

      return current && (current < startDate || current > endDate);
    },
  };

  return {
    continueButtonDisalbed,
    onChangeFormItem,
    disabledDate,
  };
};

export default useFormItemReaction;
